import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Steps from './Steps';

class Registration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStepIndex: 0,
    };
    this.nextStep = () => this.setState({ currentStepIndex: this.state.currentStepIndex + 1 });
    this.prevStep = () => {
      this.setState({ currentStepIndex: this.state.currentStepIndex - 1 })
    };
  }

  componentWillReceiveProps(props) {
    let index = this.state.currentStepIndex;
    if (this.props.registerConfirmed === false && props.registerConfirmed === true) index = 1;
    this.setState({ 
      profileIsNew: false,
      passportIsNew: false,
      addressIsNew: false,
      vehicleIsNew: false
    });
    if (props.profileErrorCode === 404) {
      this.setState({ profileIsNew: true });
      index = 2;
    } else if (props.passportErrorCode === 404) {
      this.setState({ passportIsNew: true });
      index = 3;
    } else if (props.addressErrorCode === 404 || props.passportAddressErrorCode === 404) {
      this.setState({ addressIsNew: true });
      index = 4;
    } else if (props.isAuthenticated && props.vehicles.length === 0) {
      this.setState({ vehicleIsNew: true });
      index = 5;
    } else if (!props.devices.length) {
      index = 6;
    }
    this.setState({ currentStepIndex: index });
  }

  render() {
    const {profileIsNew, addressIsNew, vehicleIsNew, passportIsNew} = this.state

    return (
      this.props.devices.length || this.props.contracts.length ?
        <Steps.Login /> : <div style={{ position: 'relative' }}>
          {this.state.currentStepIndex === 0 ? <Steps.ActivationStep increaseStepIndex={this.nextStep} decreaseStepIndex={this.prevStep}/> : null}
          {this.state.currentStepIndex === 1 ? <Steps.Login isAfterConfirm increaseStepIndex={this.nextStep} decreaseStepIndex={this.prevStep} /> : null}
          {this.state.currentStepIndex === 2 ? <Steps.ProfileStep increaseStepIndex={this.nextStep} decreaseStepIndex={this.prevStep} profileIsNew={profileIsNew}/> : null}
          {this.state.currentStepIndex === 3 ? <Steps.PassportStep increaseStepIndex={this.nextStep} decreaseStepIndex={this.prevStep} passportIsNew={passportIsNew}/> : null}
          {this.state.currentStepIndex === 4 ? <Steps.AddressStep increaseStepIndex={this.nextStep} decreaseStepIndex={this.prevStep} addressIsNew={addressIsNew}/> : null}
          {this.state.currentStepIndex === 5 ? <Steps.VehicleStep increaseStepIndex={this.nextStep} decreaseStepIndex={this.prevStep} vehicleIsNew={vehicleIsNew}/> : null}
          {this.state.currentStepIndex === 6 ? <Steps.SigningStep increaseStepIndex={this.nextStep} decreaseStepIndex={this.prevStep}/> : null}
        </div>
    );
  }
}

Registration.propTypes = {
  profileErrorCode: PropTypes.number,
  addressErrorCode: PropTypes.number,
  passportErrorCode: PropTypes.number,
  passportAddressErrorCode: PropTypes.number,
  vehiclesErrorCode: PropTypes.number,
  registerConfirmed: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  devices: PropTypes.array,
  contracts: PropTypes.array,
};

export default connect(
  (state) => {
    return {
      addressErrorCode: state.settings.addressErrorCode,
      profileErrorCode: state.settings.profileErrorCode,
      passportErrorCode: state.settings.passportErrorCode,
      passportAddressErrorCode: state.settings.passportAddressErrorCode,
      vehicles: state.settings.vehicles,
      registerConfirmed: state.auth.registerConfirmed,
      isAuthenticated: state.auth.isAuthenticated,
      devices: state.devices.devices,
      contracts: state.contracts.contracts,
    };
  },
  () => ({}),
)(Registration);



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/index.js